import type { CopyShape } from "@tami/core/intl";

import type { DEMO_TABS_COPY_PT_BR } from "../demo-tabs.copy";

export const DEMO_TABS_COPY_ES_ES: CopyShape<typeof DEMO_TABS_COPY_PT_BR> = {
  painel: "Panel",
  creators: "Creators",
  notas: "Notas",
  conteudo: "Contenido",
  campanhas: "Campañas",
  financas: "Finanzas",
  calculadora: "Calculadora",
  desempenho: "Rendimiento",
  agenda: "Calendario",
  equipe: "Flujo",
  whatsapp: "WhatsApp",
};
